import { createElement, getUiRoot, setText } from './dom';
import { currentLanguage, onLanguageChange, setLanguage } from './i18n';

export function createLanguageToggle(): void {
  const button = createElement('button', 'language-toggle', getUiRoot());
  button.type = 'button';
  const refresh = (): void => {
    setText(button, currentLanguage() === 'en' ? 'Nederlands' : 'English');
    button.lang = currentLanguage() === 'en' ? 'nl' : 'en';
    button.setAttribute(
      'aria-label',
      currentLanguage() === 'en' ? 'Switch to Dutch' : 'Switch to English'
    );
  };
  onLanguageChange(refresh);
  button.addEventListener('click', () => {
    setLanguage(currentLanguage() === 'en' ? 'nl' : 'en');
  });
  setLanguage(currentLanguage());
  refresh();
}
